import type { ReactNode } from 'react'
import {
  Tooltip as BaseTooltip,
  TooltipContent,
  TooltipTrigger,
} from './ui/tooltip'

interface Props {
  children: ReactNode
  className?: string
  triggerClassName?: string

  content: ReactNode
  asChild?: boolean
  sideOffset?: number
}

export function Tooltip({
  children,
  className,
  triggerClassName,

  content,
  asChild = true,
  sideOffset = 4,
}: Props) {
  return (
    <BaseTooltip>
      <TooltipTrigger className={triggerClassName} asChild={asChild}>
        {children}
      </TooltipTrigger>

      <TooltipContent className={className} sideOffset={sideOffset}>
        {content}
      </TooltipContent>
    </BaseTooltip>
  )
}
